import jwPlayerComponent from "./jwPlayerComponent";

function modalComponent() {
    let modalLinks = document.querySelectorAll("[data-open-modal]");

    let save_content = null;
    let modalToLoad = null;


    for (let modalLink of modalLinks) {
        modalLink.addEventListener("click", function() {
            let idModalToLoad = modalLink.getAttribute("data-open-modal");
            modalToLoad = document.getElementById(idModalToLoad);
            
            let backdrop = document.createElement("div");
            backdrop.classList.add("panel-drop-background");
            document.body.classList.add("no-scroll");
            document.body.appendChild(backdrop);

            let componentModal = null;
            if (modalToLoad) {
                componentModal = document.createElement("div");
                componentModal.classList.add("component-modal");
                let componentModalWindow = document.createElement("div");
                componentModalWindow.classList.add("component-modal__window");
                componentModal.appendChild(componentModalWindow);

                save_content = modalToLoad.innerHTML;
                modalToLoad.innerHTML = '';

                var range = document.createRange()
                range.setStart(componentModalWindow, 0)
                componentModalWindow.appendChild(
                  range.createContextualFragment(save_content)
                )

                setTimeout(function(){
                    jwPlayerComponent()
                }, 200)
            }

            setTimeout(function() {
                backdrop.classList.add("panel-drop-background--show");
                if(componentModal) {
                    setTimeout(function() {
                        document.body.appendChild(componentModal);
                    }, 100);
                }
            }, 50);

            history.pushState({}, "");
            let fnRemoveBackdrop = () => {
                modalToLoad.innerHTML = save_content;

                if (componentModal) {
                    document.body.removeChild(componentModal);
                }
                document.body.classList.remove("no-scroll");
                backdrop.classList.remove("panel-drop-background--show");
                setTimeout(function() {
                    document.body.removeChild(backdrop);
                }, 250);
            };
            
            if (componentModal) {
                componentModal.addEventListener("click", function(ev) {
                    if(ev.target === componentModal) {
                        history.back();
                    }
                });
            } else {
                backdrop.addEventListener("click", function(ev) {
                    if(ev.target === backdrop) {
                        history.back();
                    }
                });
            }

            window.addEventListener("popstate", function() {
                fnRemoveBackdrop();
            });
        });
    }
}

export default modalComponent;